import { selectUserId } from 'containers/Login/loginSlice'
import { useEffect, useState } from 'react'
import { paymentMethod } from 'rest/urls'
import { useReduxSelector } from 'store'
import { POST } from 'rest/request'

/** Pełna definicja metody (z cardForm / walletForm) żyje w src/types/payments.d.ts */
export type PaymentMethod = payments.PaymentMethod

const usePaymentMethods = (
  invoiceIds?: string[],
  _paymentMethods?: PaymentMethod[],
  /** np. ['saved_method'] - metoda pojawi się tylko gdy jawnie o nią poprosimy */
  acceptedMethods?: string[]
) => {
  const userId = useReduxSelector(selectUserId)
  const [isLoading, setLoading] = useState(true)
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[] | undefined>(_paymentMethods)

  const getPaymentMethods = async (_userId: string, _invoiceIds?: string[], _acceptedMethods?: string[]) => {
    if (!_userId) return
    try {
      const body: Record<string, unknown> = { userId: _userId }
      if (_invoiceIds) body.invoiceIds = _invoiceIds
      if (_acceptedMethods?.length) body.acceptedMethods = _acceptedMethods

      const response = await POST(paymentMethod, { body })
      if (response && typeof response === 'object') {
        setLoading(true)
        setPaymentMethods(Object.values(response))
      } else {
        throw new Error('Wrong response')
      }

    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!_paymentMethods) {
      getPaymentMethods(userId, invoiceIds, acceptedMethods)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, invoiceIds, _paymentMethods, acceptedMethods])

  return {
    isLoading,
    paymentMethods
  }
}

export default usePaymentMethods
